import React, { useEffect, useRef, useState } from "react";
import classNames from "classnames/bind";
import ClipboardJS from "clipboard";

import { ScreenInfo } from "../../components/ScreenInfo";
import { Footer } from "../../components/Footer";
import { Button } from "../../components/Button";

import { useStateManager } from "utils/useStateManager";
import { UserType } from "types/UserType";
import { getQueryVariable } from "../../utils/getQueryVariable";

import styles from "./Finish.module.css";

const cx = classNames.bind(styles);

type Tooltip = {
  type: "SUCCESS" | "ERROR";
  text: string;
};

const userLabel = {
  [UserType.LITE]: "консультанту",
  [UserType.PRO]: "специалисту",
};

export const Finish: React.FC<{}> = () => {
  const { userType, linkInfo } = useStateManager();
  const label = userLabel[userType];
  const ref = useRef<HTMLButtonElement>(null);
  const [tooltip, setTooltip] = useState<Tooltip | null>(null);

  useEffect(() => {
    if (ref.current) {
      const instance = new ClipboardJS(ref.current, {
        text: () => {
          const invitationText = linkInfo?.link!.split("http")[0];

          if (getQueryVariable("i")) {
            return invitationText + window.location.href.split("?")[0] + "?" + linkInfo?.link!.split("?")[1];
          }
          return invitationText + window.location.href;
        },
      });

      instance.on("success", () => {
        setTooltip({
          type: "SUCCESS",
          text: "Ссылка скопирована",
        });

        setTimeout(() => {
          setTooltip(null);
        }, 1000);
      });

      instance.on("error", () => {
        setTooltip({
          type: "ERROR",
          text: "Произошла ошибка",
        });

        setTimeout(() => {
          setTooltip(null);
        }, 1000);
      });

      return () => instance.destroy();
    }
  }, [ref.current]);

  return (
    <ScreenInfo icon={null} title="Спасибо, вы завершили опрос">
      <p className={cx("info")}>
        {linkInfo?.custom?.custom_additional_data?.replacement1 || `Мы уже отправили письмо об этому вашему ${label}.`}
        <br />
        <br />С вами свяжутся для продолжения работы или обратитесь к {
          label
        }{" "}
        самостоятельно, в зависимости от договоренностей.
      </p>

      {linkInfo?.link && (
        <>
          <p className={cx("link")}>
            Хотите предложить такой же тест близкому человеку?
            <br />
            Просто передайте эту ссылку любым удобным способом:
          </p>
          <Button color="white" size="small" type="button" ref={ref}>
            Скопировать ссылку
          </Button>
          <div
            className={cx("tooltip", {
              tooltip_error: tooltip?.type === "ERROR",
              tooltip_visible: !!tooltip,
            })}
          >
            {tooltip?.text}
          </div>
        </>
      )}

      <Footer />
    </ScreenInfo>
  );
};
